<template>
  <div class="banner-top">
    <div class="cash-back">
      <div class="text">
        <div class="text-get">
          {{ $t('get') }}
        </div>
        <img src="@/assets/image/activity/invite/icon-get-cash.png" class="icon-get-cash">
      </div>
      <div class="icon">
        {{ $t('cashBack') }}
      </div>
    </div>
    <div class="cash-amount">
      <div class="return-tip1">{{ $t('returnTip1') }}</div>
      <div class="return-tip2">{{ $t('returnTip2') }}</div>
    </div>
    <div class="bubble">
      {{ $t('bubbleTip') }}
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        get: 'Get',
        cashBack: 'Voucher',
        returnTip1: 'Plus 1% from total funding',
        returnTip2: 'Reward your friend, Reward yourself',
        bubbleTip: 'My friends will get 1% interest bonus plus Rp 9.999 cashback',
      },
      id: {
        get: 'Dapatkan',
        cashBack: 'Voucher',
        returnTip1: 'Raih 1% dari total pendanaan',
        returnTip2: 'Teman Untung, Kamu Untung',
        bubbleTip: 'My friends will get 1% interest bonus plus Rp 9.999 cashback',
      },
    },
  },
}
</script>

<style scoped lang="stylus">
.banner-top {
  background-image: url('../../../assets/image/activity/invite/bg-top.png');
  background-size: 100% 100%;
  min-height: 595px;
}

.cash-back {
  padding: 30px 50px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
  .text {
    display: flex;
    justify-content: flex-start;
    .text-get {
      font-size: 26px;
      font-weight: bold;
      color: #fff;
      line-height: 49px;
      text-shadow: 0px 2px 4px rgba(10, 0, 69, 0.5);
      margin-right: 5px;
    }
    .icon-get-cash {
      width: 17px;
      height: 26px;
    }
  }
  .icon {
    width: 99px;
    height: 33px;
    background-image: url('../../../assets/image/activity/invite/bg-cash-back.png');
    background-size: 100% 100%;
    color: #fff;
    padding: 5px 0;
    text-align: center;
    font-style: italic;
    font-weight: 600;
    font-size: 15px;
  }
}

.cash-amount {
  margin: 0 18px;
  padding-top: 112px;
  background-image: url('../../../assets/image/activity/invite/bg-amount.png');
  background-size: 100% 100%;
  min-height: 219px;
  color: #fff;
  text-align: center;
  .return-tip1 {
    font-size: 18px;
    line-height: 22px;
    font-weight: bold;
  }
  .return-tip2 {
    font-size: 14px;
    line-height: 18px;
  }
}

.bubble {
  width: 126px;
  height: 74px;
  background-image: url('../../../assets/image/activity/invite/bg-bubble.png');
  background-size: 100% 100%;
  margin: -55px 0 0 156px;
  font-size: 10px;
  font-weight: bold;
  line-height: 12px;
  color: #6B6F83;
  padding: 15px 0 0 15px;
}
</style>
